import type { Link, RichText } from '@wix/public-schemas'

export type LinkWithId = Link & { id: string }

export type UnresolvedRichText = {
	text: string
	linkList: Array<LinkWithId>
}

const getLinkAttributes = (linkProps?: Link): string => {
	if (linkProps) {
		return Object.keys(linkProps)
			.filter((key) => key !== 'id' && linkProps[key as keyof Link])
			.map((key) => `${key}="${linkProps[key as keyof Link]}"`)
			.join(' ')
	}
	return ''
}

const joinAttributesParts = (attributesParts: Array<string>): string =>
	attributesParts
		.filter((attributesPart) => attributesPart !== '')
		.map((attributesPart) => attributesPart.trim())
		.join(' ')

const convertDataQueryLinksToHtmlAnchors = (text: string, linkList: Record<string, Link>) =>
	text.replace(/<a ([^>]*)dataquery="#([^"]+)"([^>]*)>/g, (_full, preAttributes, dataQuery, postAttributes) => {
		const linkProps = linkList[dataQuery]
		const fixedAttributes = joinAttributesParts([preAttributes, getLinkAttributes(linkProps), postAttributes])
		return `<a${fixedAttributes ? ` ${fixedAttributes}` : ''}>`
	})

export type RichTextResolver = (richText: UnresolvedRichText) => RichText
export const resolveRichText: RichTextResolver = (richText) => {
	const { text, linkList } = richText
	const linkMap = linkList.reduce((acc, link) => {
		acc[link.id] = link
		return acc
	}, {} as Record<string, Link>)
	return { html: convertDataQueryLinksToHtmlAnchors(text, linkMap), linkList, text }
}
